/** The ⓘ beside a card label or panel title: hover (or focus) shows what
 *  the figure or chart means. Native tooltip, so it works everywhere with
 *  no library and reads out to screen readers through the aria-label. */
export function Info({ text }: { text: string }) {
  return (
    <span
      role="img"
      tabIndex={0}
      aria-label={text}
      title={text}
      className="inline-flex size-[15px] shrink-0 cursor-help items-center justify-center rounded-full border border-border text-[10px] font-semibold leading-none text-muted normal-case tracking-normal hover:border-accent hover:text-accent focus:outline-none focus:ring-2 focus:ring-accent/40"
    >
      i
    </span>
  );
}
